import { Box, CircularProgress } from '@mui/material'

/**
 * Candidate for own component, or extension on our default spinner :)
 * Lets wait for design system, when failover is shown we do not have the theme yet
 * so hence our fixed color
 */
export const FallbackApplication = () => (
  <Box sx={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
    <CircularProgress size={72} sx={{ color: 'primary.main' }} />
  </Box>
)
